<script setup>
import { computed } from "vue";

import WordListItem from "./WordListItem.vue";

const props = defineProps({
  items: {
    type: Array,
    required: true
  },
  sm: {
    type: Number,
    default: 2
  },
  md: {
    type: Number,
    default: undefined
  },
  lg: {
    type: Number,
    default: undefined
  }
});

const emit = defineEmits(["deleteWord", "unlockWord"]);

// When one prop is defaulted to another, it doesn't react to changes.
// e.g. if you don't provide props.lg, and props.md changes reactively, it won't be reflected on a >md screen.
const breakpoints = computed(() => ({
  sm: props.sm,
  md: props.md ?? props.sm,
  lg: props.lg ?? props.md
}));
</script>

<template>
  <ul class="word-list-item-grid">
    <li v-for="(item, index) in props.items" :key="index" class="word-list-item-grid__item">
      <WordListItem
        :word-id="item.id ?? 0"
        :locked="item.locked"
        :deletable="item.deletable"
        :source-word="item.lemma"
        :target-word="item.translation"
        :word-class="item.lemmaWordclass.short"
        :source-word-pronunciation-url="item.lemmaPronunciationFileUrl"
        @unlock="emit('unlockWord', item.id)"
        @delete="emit('deleteWord', item.id)"
      />
    </li>
  </ul>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.word-list-item-grid {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(v-bind("breakpoints.sm"), 1fr);
  width: 100%;
  margin: 0;
  padding: 0;

  // List default styling
  list-style: none;

  #media-breakpoint-up(md, {
    width: auto;
    grid-template-columns: repeat(v-bind("breakpoints.md"), minmax(170px, 1fr));
  });

  #media-breakpoint-up(lg, {
    grid-template-columns: repeat(v-bind("breakpoints.lg"), minmax(170px, 1fr));
  });

  &__item {
    overflow: hidden;
  }
}
</style>
